<template>
  <div class="lg:flex lg:flex-row-reverse px-4 mb-20 lg:mb-40">
    <div class="w-full lg:w-[651px]">
      <div>
        <div class="text-title text__headline-4-xs--bold lg:text__headline-3-md--bold">
          {{ everyStudent.title }}
        </div>
      </div>
      <div class="mt-4 lg:mt-6">
        <BaseExpansionDiv
          height-default="max-h-[125px] lg:max-h-[135px]"
          justify-btn="start"
        >
          <template #content>
            <div class="text-body-1 text__body-2--md--regular" v-html="everyStudent.description" />
          </template>
        </BaseExpansionDiv>
      </div>
    </div>
    <div class="mx-auto flex justify-center mr-14">
      <img
        data-src="@images/public/how-it-work/every-student.png"
        class="lazyload mx-auto w-full lg:auto lg:h-[353px]"
        :alt="everyStudent.title"
      >
    </div>
  </div>
</template>
<script>
import staticData from './static-data'

export default {
  name: 'EveryStudent',
  data () {
    return {
      everyStudent: staticData.component.EveryStudent
    }
  }
}
</script>
